<div
  class="wbs-container"
  *ngIf="permissionObj['Intake_Submission_WBS_Visible']"
>
  <div class="d-flex flex-column">
    <div class="wbs-label">
      <span
        class="icon-required-yellow"
        *ngIf="!wbsChargeCode && !pendingWBSCheckboxValue"
      ></span>
      <span class="eclipse-small-header-grey text-align-left"
        >Charge code (WBS):</span
      >
      <span
        ddsFocus
        class="icon-s icon-info"
        ddsTooltip="This WBS is used to connect with Archive It for document retention."
        [tooltipInvokeType]="tooltipOptions.tooltipInvokeType ?? _EMPTY"
        [tooltipType]="tooltipOptions.tooltipType ?? _EMPTY"
        [tooltipSize]="tooltipOptions.tooltipSize ?? _EMPTY"
        [tooltipPosition]="tooltipOptions.tooltipPosition ?? _EMPTY"
        [tooltipIndent]="tooltipOptions.tooltipIndent ?? 0"
        [tooltipHasBeak]="tooltipOptions.tooltipHasBeak ?? false"
        [tooltipTheme]="tooltipOptions.tooltipTheme ?? _EMPTY"
        (click)="$event.stopPropagation()"
      >
      </span>
    </div>
    <app-generic-picker
      class="intake-wbs-picker"
      [width]="'20rem'"
      [items]="searchList"
      [placeholder]="'Search WBS'"
      [showDropdown]="showWBSDropdown"
      [isSpinnerVisible]="true"
      [isLoading]="isFetchingWBSData"
      [selectedItem]="
        showPendingWBSCheckbox || pendingWBSCheckboxValue ? '' : wbsChargeCode
      "
      [isPickerDisabled]="
        pendingWBSCheckboxValue ||
        !permissionObj['Intake_Submission_WBS_Enable']
      "
      [showEditIcon]="permissionObj['Intake_Submission_WBS_Enable']"
      (editItem)="editWBSChargeCode()"
      (clearSearch)="wbsFieldCleared()"
      (searchText)="onWBSSearchTextChange($event)"
      (fetchMoreData)="fetchMoreWbsResult()"
      (selectItem)="onWbsChargeCodeSelect($event)"
    ></app-generic-picker>
    <dds-checkbox
      *ngIf="showPendingWBSCheckbox"
      class="intake-wbs-picker"
      [value]="pendingWBSCheckboxValue"
      [(ngModel)]="pendingWBSCheckboxValue"
      [theme]="checkboxThemeColor"
      label="WBS Pending"
      [disabled]="!permissionObj['Intake_Submission_WBS_Enable']"
      (stateChanged)="wbsPendingCheckboxChange($event)"
    >
    </dds-checkbox>
  </div>
  <ng-container *ngIf="showDescriptionAndArchive">
    <div
      *ngIf="permissionObj['Intake_Submission_WBSDescription_Visible']"
      class="d-flex flex-column"
    >
      <div class="eclipse-small-header-grey text-align-left">
        WBS Description
      </div>
      <div>
        {{ wbsDescription ? wbsDescription : defaultForEmptyFields }}
      </div>
    </div>
    <div class="d-flex flex-column">
      <div class="wbs-label">
        <span
          class="icon-required-yellow"
          *ngIf="!selectedArchive && !isFetchingArchiveData"
        ></span>
        <span class="eclipse-small-header-grey text-align-left">Archive:</span>
      </div>
      <div
        *ngIf="showArchiveDropdown; else showArchiveDetails"
        class="relative"
      >
        <dds-select
          class="archive-select"
          [placeholder]="archiveSelectOptions.placeholder ?? _EMPTY"
          [list]="archiveDropdownList"
          [stickerMaxHeight]="'15rem'"
          [(ngModel)]="selectedArchive"
          [disabled]="
            !permissionObj['Intake_AllSubmissionTypes_CloseoutForm_Enable'] ||
            isFetchingArchiveData
          "
          (ngModelChange)="onArchiveSelect()"
          (stickerHidden)="archiveStickerHidden()"
        >
        </dds-select>
        <div *ngIf="isFetchingArchiveData" class="loader">
          <dds-spinner
            [size]="spinnerOptions.size ?? _EMPTY"
            [theme]="spinnerOptions.theme ?? _EMPTY"
            [isInverse]="spinnerOptions.isInverse ?? false"
            [thickness]="spinnerOptions.thickness ?? _EMPTY"
          ></dds-spinner>
        </div>
      </div>
      <ng-template #showArchiveDetails>
        <div class="d-flex">
          <span
            [ddsTooltip]="wbsArchiveSwiftdetails"
            [tooltipInvokeType]="tooltipOptions.tooltipInvokeType ?? _EMPTY"
            [tooltipType]="tooltipOptions.tooltipType ?? _EMPTY"
            [tooltipSize]="tooltipOptions.tooltipSize ?? _EMPTY"
            [tooltipPosition]="tooltipOptions.tooltipPosition ?? _EMPTY"
            [tooltipIndent]="tooltipOptions.tooltipIndent ?? 0"
            [tooltipHasBeak]="tooltipOptions.tooltipHasBeak ?? false"
            [tooltipIsDisabled]="tooltipOptions.tooltipIsDisabled ?? false"
            [tooltipIsInverse]="tooltipOptions.tooltipIsInverse ?? false"
            [tooltipTheme]="tooltipOptions.tooltipTheme ?? _EMPTY"
            [tooltipCustomClass]="tooltipOptions.tooltipCustomClass ?? _EMPTY"
            ddsFocus
            [tooltipMaxWidth]="tooltipOptions.tooltipMaxWidth ?? 0"
            class="dds-link"
          >
            {{ archiveDescription }}</span
          >
          <span
            *ngIf="!isFetchingArchiveData"
            class="dds-icon dds-icon_edit__s__filled margin-left-xs cursor-clickable"
            aria-label="Edit Archive Details"
            aria-placeholder="Edit Archive Details"
            title="Edit Archive Details"
            (click)="$event.stopPropagation(); editArchiveDetails()"
          ></span>
        </div>
      </ng-template>
    </div>
  </ng-container>
</div>

<ng-template #wbsArchiveSwiftdetails>
  <div class="w-fit-content h-fit-content">
    <div class="d-flex" *ngIf="selectedArchive != archiveNotListedMsg">
      <div class="padding-xs">Archive name:</div>
      <div class="padding-xs font-bold-600">
        {{ archiveDescription ? archiveDescription : defaultForEmptyFields }}
      </div>
    </div>
    <div class="d-flex" *ngIf="selectedArchive != archiveNotListedMsg">
      <div class="padding-xs">Archive description:</div>
      <div class="padding-xs font-bold-600">
        {{
          archive?.archiveDescription
            ? archive?.archiveDescription
            : defaultForEmptyFields
        }}
      </div>
    </div>
    <div class="d-flex">
      <div class="padding-xs">Swift project name:</div>
      <div class="padding-xs font-bold-600">
        {{ swiftDetails?.projectName ?? defaultForEmptyFields }}
      </div>
    </div>
    <div class="d-flex">
      <div class="padding-xs">Swift project start:</div>
      <div class="padding-xs font-bold-600">
        {{ swiftDetails?.projectStartDate ?? defaultForEmptyFields }}
      </div>
    </div>
    <div class="d-flex">
      <div class="padding-xs">Swift project end:</div>
      <div class="padding-xs font-bold-600">
        {{ swiftDetails?.projectEndDate ?? defaultForEmptyFields }}
      </div>
    </div>
    <div>
      <div class="padding-xs">Swift project PPMD:</div>
      <div class="padding-xs font-bold-600">
        {{ swiftDetails?.projectPPMD ?? defaultForEmptyFields }}
      </div>
    </div>
  </div>
</ng-template>
